// internal-deps
import { format } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";
import { RawOrderData } from "@swiggy-private/payment-types";
import {
    CHECKOUT_THEME_QUERY_PARAM,
    clearAuthHeadersFromStorage,
    getBridgeSdk,
    getCheckoutThemeName,
    getNativeChannelDeepLink,
} from "@swiggy-private/checkout-core";
import { NavigateToScreenRequestPayload, NavigationTypes } from "@swiggy-private/native-bridge";

// constants
import { WEB_VIEW_URL } from "@dineout-payment-success-ui/constants";

// helpers
import { getHelpWebviewUrl } from "./PaymentSuccessHelper";

export function postOrderEventHelper(orderData: RawOrderData, clearHeaders: boolean): void {
    if (clearHeaders) {
        clearAuthHeadersFromStorage();
    }

    getBridgeSdk()
        .postOrderEvent(orderData)
        .catch(() => void 0);
}

interface IOpenHelpWebViewParams {
    orderId?: string;
    restaurantId?: string;
    isEventReservation?: boolean;
    isStealStoreFlow?: boolean;
    isCouponPurchase?: boolean;
}

export const openHelpWebView = ({
    orderId,
    restaurantId,
    isEventReservation,
    isStealStoreFlow,
    isCouponPurchase,
}: IOpenHelpWebViewParams) => {
    const helpWebUrl = getHelpWebviewUrl(isEventReservation, isStealStoreFlow, isCouponPurchase);
    const theme = getCheckoutThemeName();
    const themeParam = theme ? `&${CHECKOUT_THEME_QUERY_PARAM}=${theme}` : "";
    const navigationLink = restaurantId
        ? `${helpWebUrl}/?action=help&showLastOrder=false&restaurantId=${restaurantId}${themeParam}`
        : `${helpWebUrl}/?showLastOrder=false&orderId=${orderId}${themeParam}`;
    const encodedUrl = encodeURIComponent(navigationLink); //need to encode for web implementation since extracting the url in bridge can cause some issues with query params in raw form
    const deeplink = format(WEB_VIEW_URL, encodedUrl) || "";
    const nativeChannelDeeplink = getNativeChannelDeepLink(deeplink);
    try {
        const data: NavigateToScreenRequestPayload = {
            type: NavigationTypes.DEEPLINK,
            link: nativeChannelDeeplink,
            params: {
                shouldCloseWebView: false,
            },
        };
        getBridgeSdk()?.navigateToScreen(data);
    } catch (err) {
        // noop
    }
};

export const navigateToLink = (
    link: string,
    shouldCloseWebview = true,
    shouldRefresh = false,
    httpHeaders?: Record<string, string>,
) => {
    getBridgeSdk().navigateToScreen({
        type: NavigationTypes.DEEPLINK,
        link,
        httpHeaders,
        params: {
            shouldCloseWebview,
            shouldRefresh,
        },
    });
};

export const getAvailableUpiPackagesForTip = async (packageNames: string[]): Promise<string[]> => {
    if (isEmpty(packageNames)) {
        return [];
    }

    try {
        const response = await getBridgeSdk()?.upiIntentAvailableMethods({ methods: packageNames });
        return response?.methods ?? [];
    } catch {
        return [];
    }
};
